<template>
  <navroot v-if="loadNav" />
  <a-spin wrapperClassName="spin-box scroll-box" :spinning="loading">
    <div class="content-box">
      <div class="single-background" :class="{ single: int }"
        :style="{ 'background-image': 'url(' + backgroundImage + ')' }" v-if="backgroundImage && !phoneMode">
        <i class="single-cover"
          :style="{ 'background-image': 'radial-gradient(1200px at center, #ffffff00,' + theme_color + '90)' }"></i>
      </div>
      <div class="list-box" v-if="!loading && !int">
        <template v-if="isNewTextbook">
          <textbookPhone :intList="intList" :stuList="stuList" :userScore="userScore" v-if="phoneMode"></textbookPhone>

          <textbookList :classInfo="classInfo" :intList="intList" :stuList="stuList" :userScore="userScore" v-else>
          </textbookList>
        </template>

        <phoneList :intList="intList" :stuList="stuList" :userScore="userScore" @chooseItem="chooseItem"
          @switchBackground="switchBackground" v-else-if="phoneMode"></phoneList>

        <pilotList :classInfo="classInfo" :intList="intList" :stuList="stuList" :userScore="userScore"
          @chooseItem="chooseItem" @switchBackground="switchBackground" v-else-if="template == 'pilot'"></pilotList>

        <flagList :classInfo="classInfo" :intList="intList" :stuList="stuList" :userScore="userScore"
          @chooseItem="chooseItem" @switchBackground="switchBackground" v-else-if="template == 'flag'"></flagList>

        <cardList :classInfo="classInfo" :intList="intList" :stuList="stuList" :userScore="userScore"
          @chooseItem="chooseItem" v-else-if="template == 'card'"></cardList>

        <normalList :classInfo="classInfo" :intList="intList" @chooseItem="chooseItem"
          @switchBackground="switchBackground" v-else></normalList>
      </div>

      <template v-if="int">
        <CardItem :int="int" v-if="template == 'card'"></CardItem>
        <listItem :int="int" @returnList="returnList" v-else></listItem>
      </template>
    </div>
    <showAchievement :showAchievement="showAchievement" type="remind" @closeBox="readedAchievement"
      v-if="showAchievement || isShowUpgrade"></showAchievement>
    <chat-npc :roleKeyword="roleKeyword" v-if="!phoneMode && is_show_npc && !isLocal"></chat-npc>
  </a-spin>
</template>

<script>
import { Modal } from 'ant-design-vue';
import { YUANXI_URL } from '@/config/url';

import navroot from "../nav/nav.vue";
import showAchievement from "../achievement/show-achievement/show-achievement.vue";
import listItem from "./list-item/list-item.vue";
import flagList from "./flag-list/flag-list.vue";
import normalList from "./normal-list/normal-list.vue";
import phoneList from "@/components/phone/phone-list/phone-list.vue";
import chatNpc from "../chat-npc/chat-npc.vue";
import pilotList from "@/components/list/pilot-list/pilot-list.vue";
import cardList from "@/components/list/card-list/card-list.vue";
import CardItem from "@/components/list/card-list/CardItem.vue";

import textbookList from "./textbook-list/textbook-list.vue"
import textbookPhone from "./textbook-list/textbook-phone/textbook-phone.vue";
import { EMOJI_LIST } from "@/components/list/textbook-list/TextbookRender/configs/emoji.js";

export default {
  components: {
    navroot, showAchievement, chatNpc,
    flagList, normalList,
    pilotList, phoneList, cardList,
    listItem, CardItem,
    textbookList, textbookPhone,
  },
  name: "login",
  data() {
    return {
      classGuid: '',
      intId: '',
      iframeUrl: '',
      backgroundImage: '',
      emptyImage: '',
      theme_color: '',
      template: '',
      platform_type: '',
      roleKeyword: '',
      classId: '',

      user: null,
      classInfo: null,
      int: null,
      showAchievement: null,
      userScore: null,

      loadNav: false,
      loading: true,
      isShowUpgrade: false,
      phoneMode: false,
      is_show_npc: false,
      isNewTextbook: false,
      isLocal: false,

      intList: [],
      stuList: [],
      notShowAchievement: [],

      myrank: 0,
      submitPercent: 100,
      score: 0,
      unit_heigth: 700
    }
  },
  async mounted() {
    const { intId, fromType, returnUrl } = this.$route.query;
    this.intId = intId;
    if (fromType) this.$store.commit('fromType', fromType);
    if (returnUrl) this.$store.commit('returnUrl', returnUrl);

    this.loadNav = true;

    this.judgePhone();
    window.addEventListener('resize', this.judgePhone);

    const { platform, isLocal, isSharer } = this.$store.state;
    const pageContent = platform.page_content['push_list'];
    this.template = pageContent.template || 'list';
    this.emptyImage = this.template != 'pilot' ? pageContent.background_image : '';
    if (platform.Type == 'sz') {
      setTimeout(() => { this.is_show_npc = true }, 3500);
    }
    this.platform_type = platform.Type;
    this.isLocal = isLocal;

    this.backgroundImage = this.emptyImage;
    this.theme_color = platform.pageConfig.theme_color;

    const { classId } = this.$route.params;
    this.refreshList(classId);
    this.subscribeStore();
  },
  methods: {
    //
    subscribeStore() {
      this.$store.subscribe((res) => {
        if (!res) return;
        const { type, payload } = res;
        if (type == 'currentInt') this.int = payload;
      })
    },
    //判断手机端
    judgePhone() {
      let w_width = window.innerWidth;
      let phoneMode = w_width < 700;
      if (this.phoneMode == phoneMode) return;

      this.phoneMode = phoneMode;
    },
    //刷新页面
    async refreshList(classGuid) {
      this.classGuid = classGuid;
      this.int = null;
      this.loading = true;

      let user = this.$store.state.userInfo;
      if (!user) return;
      this.user = user;

      this.setClassInfo();
    },
    //获取班级信息
    async setClassInfo() {
      const res = await this.$api.unifydata.getClassInfo({ classGuid: this.classGuid });
      if (res.statusCode != 200) return this.$message.warning('获取班级信息失败');
      const { classInfo, inductionList: intList } = res.data;
      this.classInfo = classInfo;
      this.$store.commit('currentClass', classInfo);

      const { ClassName, Config } = classInfo;
      let roleKeyword = '';
      if (Config) {
        const config = JSON.parse(Config);
        roleKeyword = config.ai_keyword;
      }
      else roleKeyword = ClassName.replace('教材', '').replace('演示', '');
      this.roleKeyword = roleKeyword;

      this.intList = intList;

      this.judgeIsBuy();
    },
    //判断用户是否购买
    async judgeIsBuy() {
      const { currentClass, isSharer } = this.$store.state;
      const { pk_store_book_id, system_id } = this.$route.query;
      this.classId = currentClass.PK_ClassGuid;

      if (!isSharer && currentClass.FK_MyPacketGuid) {
        const data = {
          userId: this.user.PK_UserGuid
        }
        if (system_id) data.system_id = system_id;
        else data.classId = this.classId;

        const res = await this.$api.unifydata.isBuyTextbookClass(data);
        const goodsId = pk_store_book_id || res.data.textbookId;
        if (res.statusCode == 200 && !res.data.isbuy) {
          Modal.confirm({
            title: '未购买教材，是否前往购买？',
            onOk: () => {
              window.location.href = `${YUANXI_URL}/payment/${goodsId}`;
            },
            onCancel: () => {
              window.location.href = `${YUANXI_URL}/course-info/${goodsId}`;
            },
          })
        }
        else this.loadFuction();
      }
      else this.loadFuction();
    },
    loadFuction() {
      this.intList.forEach(int => {
        if (int.TextbookContent) {
          const textbookContent = JSON.parse(int.TextbookContent);

          let content = textbookContent.content;
          EMOJI_LIST.forEach((emoji) => {
            content = content.replace(
              new RegExp(`<span[^>]*>:${emoji.shortcode}:<\\/span>`, "g"),
              `${emoji.ico}`
            );
          });

          //使用正则表达式提取标题标签
          const regex = /<h[1-6][^>]*>(.*?)<\/h[1-6]>/g;
          const matches = content.match(regex);
          let newMatches = [];
          if (matches) {
            matches.forEach((item) => {
              const levels = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
              for (const level of levels) {
                if (item.includes(level)) {
                  item = `${this.removeHTMLTags(level, item)}`;
                  newMatches.push(item);
                }
              }
            })
          }
          int.showTextbookContent = newMatches.join("");
        }
      })

      if (this.classInfo.IsNewTextbook) {
        this.isNewTextbook = true;
        this.intList.forEach((int, i) => {
          int.chapter_num = i;
          int.children.forEach(code => { code.chapter_num = i })
        })
        this.getMyTeam()
      }
      else {
        this.translationInt(this.intList);
      }
    },
    //去除html
    removeHTMLTags(level, html) {
      var tmp = document.createElement("div");
      tmp.innerHTML = html;
      let id = $(html).attr('data-id')
      if (!id) return '';

      id = id.replaceAll('\\"', '');
      let text = tmp.textContent || tmp.innerText || "";
      return `<${level} nav-data-id="${id}">${text}</${level}>`
    },

    //获取单元互动信息
    translationInt(intList) {
      //互动初始高度
      intList.forEach((int, i) => {
        int.chapter_num = i;
        int.children.forEach(citem => {
          citem.data.forEach(code => {
            code.height = 600;
            code.fold = true;
            code.chapter_num = i;
            if (code.ProjectCode == 'co') code.phoneIframe = code.phoneIframe.replace('clientcollision', 'mobileclientcollision');
          })
        })

        int.allcode.forEach(code => {
          code.height = 600;
          code.fold = true;
          code.chapter_num = i;
          if (code.ProjectCode == 'co') code.phoneIframe = code.phoneIframe.replace('clientcollision', 'mobileclientcollision');
        })
      })
      this.intList = intList;
      this.getMyTeam();
    },
    //获取我的团队
    async getMyTeam() {
      let myTeamList = await this.$api.unifydata.getMyTeamList({ classGuid: this.classGuid }).then(res => res.data || []);
      //找到对应的应用
      myTeamList.forEach(item => {
        item.allcode = [];
        this.intList.forEach(int => {
          let allcode = int.allcode.filter(aitem => aitem.FK_GroupSchemeGuid == item.FK_GroupSchemeGuid);
          item.allcode = item.allcode.concat(allcode)
        })
      })
      this.$store.commit('myTeamList', myTeamList);
      this.setStudentScore()
    },

    //获取学生提交记录
    async setStudentScore() {
      let res = await this.$api.unifydata.getScoreList({ classGuid: this.classGuid });
      if (res.statusCode != 200) return this.$message.warning('获取学生信息失败');
      let stuList = res.data || [];
      let userScore;
      //找到我
      stuList.forEach((item, i) => {
        if (this.user.PK_UserGuid == item.PK_UserGuid) {
          userScore = item;
          this.myrank = i + 1;
          this.score = item.Score;
        }
      })
      this.userScore = userScore;

      let intList = this.intList;
      let allSubmitNum = 0;
      let allNeedNum = 0;
      intList.forEach(int => {
        int.submitNum = 0;
        int.isFinished = int.allcode.length > 0 ? true : false;
        if (!this.isNewTextbook) {
          int.children.forEach(cint => {
            cint.data.forEach(code => {
              code.isSubmited = false;
              if (userScore) {
                let record = userScore.record.find(reItem => reItem.id == code.Guid);
                if (record && record.state == 1) {
                  int.submitNum += 1;
                  code.isSubmited = true;
                  code.submitTime = record.date;
                }
              }

              if (!code.isSubmited) int.isFinished = false;
            })
          })
        }
        else {
          int.children.forEach(code => {
            code.isSubmited = false;
            if (userScore) {
              let record = userScore.record.find(reItem => reItem.id == code.Guid);
              if (record && record.state == 1) {
                int.submitNum += 1;
                code.isSubmited = true;
                code.submitTime = record.date;
              }
            }

            if (!code.isSubmited) int.isFinished = false;
          })
        }
        int.submitPercent = int.allcode.length > 0 ? Math.round(int.submitNum / int.allcode.length * 100) : 0;
        allNeedNum += int.allcode.length;
        allSubmitNum += int.submitNum;
      });
      if (allNeedNum > 0) this.submitPercent = Math.round(allSubmitNum / allNeedNum * 100);
      //找到最近完成的互动
      let lastSubmitTime = null;
      intList.forEach(int => {
        if (!this.isNewTextbook) int.children = int.children.filter(citem => citem.data.length > 0);
        int.lastSubmitTime = null;
        int.allcode.forEach(code => {
          if (!int.lastSubmitTime && code.submitTime) int.lastSubmitTime = code.submitTime;
          else if (int.lastSubmitTime && code.submitTime && (new Date(code.submitTime) > new Date(int.lastSubmitTime))) int.lastSubmitTime = code.submitTime;
        })
      });
      intList.forEach(int => {
        if (!lastSubmitTime && int.lastSubmitTime) lastSubmitTime = int.lastSubmitTime;
        else if (lastSubmitTime && int.lastSubmitTime && (new Date(int.lastSubmitTime) > new Date(lastSubmitTime))) lastSubmitTime = int.lastSubmitTime;
      })
      intList.forEach(int => {
        if (int.lastSubmitTime && int.lastSubmitTime == lastSubmitTime) int.isLastSubmit = true;
        int.allcode.forEach(code => {
          if (code.submitTime && code.submitTime == int.lastSubmitTime) code.isLastSubmit = true;
        })
      })

      //选中了单元
      if (this.intId) {
        intList.forEach((item) => {
          if (item.PK_InductionGuid == this.intId) this.chooseItem(item);
        })
      }
      this.intList = intList;
      this.stuList = stuList;
      this.loading = false;
      this.$store.commit('intList', intList);

      if (!this.userScore) return;

      let { levelInfo, achievement } = this.userScore;
      levelInfo.achievement = achievement;
      this.$store.commit('levelInfo', levelInfo);
      this.$store.commit('userScore', userScore);
      this.$store.commit('stuList', stuList);

      this.notShowAchievement = achievement.filter(item => !item.isShow);
      this.findNotShowAchievement();
    },
    //选择其中一个
    chooseItem(item) {
      if (this.template != 'card') {
        if (item.Cover) this.backgroundImage = item.Cover;
        else this.backgroundImage = this.emptyImage;
      }

      this.$router.push(`${this.$route.path}?intId=${item.PK_InductionGuid}`);
      this.$store.commit('currentInt', item);

      this.int = item;
    },
    //返回
    returnList() {
      this.int = null;
      this.intId = '';

      const path = this.$route.path;
      this.$router.push({ path: path, query: { intId: undefined } });

      this.backgroundImage = this.emptyImage;
    },
    //切换背景
    switchBackground(cover) {
      this.backgroundImage = cover || this.emptyImage;
    },
    //找到未提示成就
    async findNotShowAchievement() {
      let { PK_UserGuid: studentId } = this.user;
      let notShowAchievement = this.notShowAchievement;
      if (this.isShowUpgrade) {
        await this.$api.unifydata.showAchievement({ studentId, classId: this.classGuid, achievementId: "", type: "level" });
      }
      else {
        let showAchievement = notShowAchievement.length > 0 ? notShowAchievement[0] : null;
        if (showAchievement) {
          let { id } = showAchievement;
          await this.$api.unifydata.showAchievement({ studentId, classId: this.classGuid, achievementId: id, type: "achievement" });
        }
        this.showAchievement = showAchievement;
      }
      this.notShowAchievement = notShowAchievement;
    },
    //已读
    async readedAchievement() {
      if (this.showAchievement) {
        let { id } = this.showAchievement;
        this.notShowAchievement = this.notShowAchievement.filter(item => item.id != id);
      }
      else this.isShowUpgrade = false;
      this.findNotShowAchievement();
    },
  },
  //beforeUnmount() {},
}
</script>

<style scoped lang="scss">
@import "./list.scss";
</style>